import React, { useState } from "react";
import { rewardDataStyle as styles } from "../redeemRewards.tailwind";
import Chip from "@mui/material/Chip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import image from "../../../../../assets/svgs/dinner_with_coach.svg";
import { uiDate } from "../../../../../lib/utils/dateAndTimeFormatting";

const EarnedRewardsData = ({ reward }) => {
  const { rewardTitle: title, pointsUsed: totalPoints, rewardCode, isRewardUsed, rewardIcon, redeemedRewardExpiryDate } = reward;

  //if reward is expired or not
  const currentDate = new Date();
  const expiryDate = new Date(redeemedRewardExpiryDate);
  const isExpired = currentDate > expiryDate;

  // if the reward is used
  const rewardStatus = isExpired ? "Expired" : isRewardUsed ? "Collected" : "Awaiting Claim";

  // State for tooltip message
  const [tooltipOpen, setTooltipOpen] = useState(false);

  // Function to copy reward code
  const copyToClipboard = () => {
    if (rewardCode) {
      navigator.clipboard.writeText(rewardCode);
      setTooltipOpen(true);
      setTimeout(() => {
        setTooltipOpen(false);
      }, 1000); // Tooltip to show text is copied (disappears after 1 second)
    }
  };

  return (
    <div className={styles.outerContainer}>
      {/* Reward Information */}
      <div className={styles.leftContainer}>
        <div className={styles.earnedRewardDetails}>
          <div className={styles.imageContainer}>
            {/* Reward Image */}
            <div className={styles.rewardDescription}>
              {/* Title with Chip */}
              <div className={styles.titleContainer}>
                {/* Title */}
                <span className={styles.heading}>{title}</span>
                {/* Points Spent */}
                <div>
                    <div className="text-[12px] text-primaryGold">
                    {!reward?.isRewardUsed && (
                      <>
                        <div>Redeemed On : {uiDate(reward?.redeemedOn)}</div>
                        <div>
                          {new Date(redeemedRewardExpiryDate) < new Date()
                            ? `Expired On : ${uiDate(redeemedRewardExpiryDate)}`
                            : `Expiry Date : ${uiDate(redeemedRewardExpiryDate)}`}
                        </div>
                      </>
                    )}
                    </div>
                </div>

                <div className={styles.totalPoints}> Points Spent - {totalPoints} Points </div>
                {/* Chip to show whether reward is used or not */}
                <Chip
                  label={rewardStatus}
                  size="small"
                  className="!leading-[21px]"
                  sx={{
                    fontSize: "9px",
                    fontWeight: "600",
                    height: "15px",
                    backgroundColor: isExpired ? "#D32F2F" : isRewardUsed ? "#0AA4D5" : "var(--primaryGold)",
                    color: "var(--themeColor)",
                    borderRadius: "4px",
                    maxWidth: "max-content",
                    padding: "2px",
                  }}
                />
              </div>

              {/* Reward Code (if available) along with copy icon */}
              {rewardCode && (
                <div className={styles.rewardCodeSection} style={{ width: "fit-content" }}>
                  {/* Reward Code */}
                  <span className={styles.codeText}>{rewardCode}</span>
                  <Tooltip title={tooltipOpen ? "Copied!" : "Copy"} arrow>
                    {/* Copy icon to copy the reward code */}
                    <ContentCopyIcon
                      onClick={copyToClipboard}
                      sx={{
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
            <img src={rewardIcon || image} alt={title} className={styles.rewardImage} />
          </div>


        </div>
      </div>
    </div>
  );
};

export default EarnedRewardsData;
